import splitOrderLines from 'utils/splitOrderLines';

const getDocumentFieldNames = (orderLines, fieldDocuments) =>
  fieldDocuments.reduce((accumulator, currentValue) => {
    if (orderLines.length > 0 && currentValue.OrderLineMax) {
      const splitedOrderLines = splitOrderLines(orderLines, currentValue.OrderLineMax);
      return [
        ...accumulator,
        ...splitedOrderLines.map((currentOrderLines) => {
          const orderLineIDs = currentOrderLines.map(orderLine => orderLine.ID).join('-');
          return `Document_${currentValue.ID}_${orderLineIDs}`;
        }),
      ];
    }
    return [
      ...accumulator,
      `Document_${currentValue.ID}`,
    ];
  }, []);

export default getDocumentFieldNames;



// WEBPACK FOOTER //
// ./src/utils/getDocumentFieldNames.js